<section class="bg-white">
    <div class="pt-16 px-4 md:ml-[290px]">
        <h2 class="mb-4 text-3xl md:text-4xl tracking-tight font-extrabold text-start text-gray-900">Propose Transaction</h2>
        <form [formGroup]="proposeForm" (ngSubmit)="createProposeTransaction()" class="space-y-8">
            <div>
                <label for="address" class="block mb-2 text-sm font-medium text-gray-900 ">Contract Address <span class="text-red-600">*</span></label>
                <input [readOnly]="true" formControlName="address" type="text" id="address" class="cursor-not-allowed block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:ring-transparent focus:border-primary-500" placeholder="Enter Contract Address" required>
            </div>
            <div>
                <label for="email" class="block mb-2 text-sm font-medium text-gray-900">Select Method <span class="text-red-600">*</span></label>
                <select (change)="onMethodChange($event)" formControlName="method" id="product_id" 
                class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-transparent focus:ring-primary-500 focus:border-primary-500 outline-none block w-full p-2.5">
                    <option value="" disabled>
                        -- Select a Method --
                    </option>
                    @for (method of methodList; track $index) {
                        <option [disabled]="method.key === 'bulkDistribution'" [value]="method.key">
                            {{ method.name }}
                        </option>
                    }
                </select>
            </div>

            @if(selectedMethod && selectedMethod?.key === 'updateLtafPercentage') {
                <div>
                    <label for="percentage" class="block mb-2 text-sm font-medium text-gray-900">Percentage <span class="text-red-600">*</span></label>
                    <input appPercentageRange formControlName="percentage" type="text" id="percentage" class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:ring-transparent focus:border-primary-500" placeholder="Enter Percentage" required>
                </div>
            } @else if (selectedMethod && selectedMethod?.key == 'bulkDistribution') {
                <div>
                    <label for="date" class="block mb-2 text-sm font-medium text-gray-900">Date <span class="text-red-600">*</span></label>
                    <input [readOnly]="true" formControlName="date" type="text" id="date" class="cursor-not-allowed block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:ring-transparent focus:border-primary-500" placeholder="Enter Date" required>
                </div>
                <div>
                    <label for="count" class="block mb-2 text-sm font-medium text-gray-900">Count <span class="text-red-600">*</span></label>
                    <input [readOnly]="true" formControlName="count" type="text" id="count" class="cursor-not-allowed block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:ring-transparent focus:border-primary-500" placeholder="Enter Count" required>
                </div>
            } @else if(selectedMethod && selectedMethod?.key === 'transfer') {
                <div>
                    <label for="wallet_address" class="block mb-2 text-sm font-medium text-gray-900">Wallet Address <span class="text-red-600">*</span></label>
                    <input formControlName="wallet_address" type="text" id="wallet_address" class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 focus:ring-transparent" placeholder="Enter Wallet Address" required>
                    @if (proposeForm.get('wallet_address')?.errors?.['invalidAddress']) {
                        <div class="text-red-600 text-sm mt-1">
                            Invalid wallet address
                        </div>
                    }
                </div>
            <div>
                <label for="amount" class="block mb-2 text-sm font-medium text-gray-900">Amount <span class="text-red-600">*</span></label>
                <input formControlName="amount" type="text" id="amount" class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-primary-500 focus:border-primary-500 focus:ring-transparent" placeholder="Enter Token Amount" appAmountValidator>
                 @if(proposeForm.get('amount')?.touched && proposeForm.get('amount')?.hasError('required')) {
                <div class="text-red-600 text-sm mt-1">
                    Amount is required.
                </div>
                }
                @if(proposeForm.get('amount')?.touched && proposeForm.get('amount')?.hasError('invalidCharacters')) {
                <div class="text-red-600 text-sm mt-1">
                    {{ proposeForm.get('amount')?.getError('invalidCharacters') }}
                </div>
                }
                @if(proposeForm.get('amount')?.touched && proposeForm.get('amount')?.hasError('multipleDecimals')) {
                <div class="text-red-600 text-sm mt-1">
                    {{ proposeForm.get('amount')?.getError('multipleDecimals') }}
                </div>
                }
                @if(proposeForm.get('amount')?.touched && proposeForm.get('amount')?.hasError('invalidUrl')) {
                <div class="text-red-600 text-sm mt-1">
                    {{ proposeForm.get('amount')?.getError('invalidUrl') }}
                </div>
                }
                @if(proposeForm.get('amount')?.touched && proposeForm.get('amount')?.hasError('zeroValue')) {
                <div class="text-red-600 text-sm mt-1">
                    {{ proposeForm.get('amount')?.getError('zeroValue') }}
                </div>
                }
            </div>
            } @else if(selectedMethod && selectedMethod?.key !== 'updateLtafPercentage'){
                <div>
                    <label for="wallet_address" class="block mb-2 text-sm font-medium text-gray-900">Wallet Address <span class="text-red-600">*</span></label>
                    <input formControlName="wallet_address" type="text" id="wallet_address" class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500" placeholder="Enter Wallet Address" required>
                    @if (proposeForm.get('wallet_address')?.errors?.['invalidAddress']) {
                        <div class="text-red-600 text-sm mt-1">
                            Invalid wallet address
                        </div>
                    }
                </div>
            } 
            <div class="sm:col-span-2">
                <label for="description" class="block mb-2 text-sm font-medium text-gray-900">Description <span class="text-red-600">*</span></label>
                <textarea formControlName="description" id="description" rows="6" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 focus:ring-transparent" placeholder="Leave a Description..."></textarea>
            </div>
            <button type="submit" [disabled]="isProcessing() || !proposeForm.valid"   [ngClass]="{
                'bg-primary-700 hover:bg-primary-800 cursor-pointer': !isProcessing() && proposeForm.valid,
                'bg-primary-500 cursor-not-allowed': isProcessing() || !proposeForm.valid
              }"
              class="py-3 px-5 text-sm font-medium text-center text-white rounded-lg sm:w-fit focus:ring-4 focus:outline-none focus:ring-primary-300"
              >
                {{isProcessing() ? 'Processing...' : 'Submit'}}
            </button>
        </form>
    </div>
  </section>